// React
import React, { useState } from "react";

// styling 
import './App.css';

// Components
import Login from "./Components/Login";
import SignUp from "./Components/SignUp";
import Home from "./Components/Home";
import WishList from "./Components/WishList";

// Modules
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate
} from "react-router-dom";


function App() {

  return (
      <Router>
        <Routes>
          // login 
          <Route path="/" element={<Login />} exact={true} />
          // sign up
          <Route path="/signup" element={<SignUp />} exact={true} />
          // home
          <Route path="/home" element={<Home />} exact={true} />
          // wishlist
          <Route path="/wishlist" element={<WishList />} exact={true} />
        </Routes>
      </Router>
  );
}

export default App;
